<mat-card class="card-content full-height-container backdrop" id="open-link-invitees-bulk">
  <mat-card-header class="mg-b-m">
    <div class="header-title">
      <mat-card-title class="primary-font-color">{{ title }}</mat-card-title>
      <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
    </div>
  </mat-card-header>
  <mat-card-content class="form-container">
    <div *ngIf="updateStage != 3">
      <div *ngIf="featureComponentMode == FeatureComponentMode.UPLOAD">
        <h1 class="page-sub-header mg-l-m">
          File Processing | Step {{ updateStage }}/3
        </h1>
        <div class="mg-l-m">
      <span *ngIf="uploadInfo.uploadInitiated">
        <i class="fa-sharp fa-thin fa-xl fa-file mg-r-s"></i> {{ uploadInfo.fileName }} ({{ uploadInfo.fileSize }})
        <span *ngIf="uploadInfo.uploadDataAvailable">
          <i class="fa-sharp fa-thin fa-circle-check fa-xl mg-l-m mg-r-s primary-color"></i>uploaded
        </span>
      </span>
        </div>
        <ag-file-upload (uploadFinished)="uploadFinished($event)" (uploadReset)="resetForm()" (uploadStarted)="uploadStarted($event)"
                        [maxFileSizeSupported]="maxFileSizeSupported" [supportedFileTypes]="this.getSupportedFileTypes()"></ag-file-upload>
      </div>
      <div *ngIf="featureComponentMode != FeatureComponentMode.UPLOAD" class="full-height-container">
        <form [formGroup]="formGroup" id="bulkUpdateForm">
          <div *ngIf="featureComponentMode != FeatureComponentMode.BULK_MAILOUT">
            <div class="flex-row mg-b-m">
              <mat-form-field>
                <mat-label>Invitation Company</mat-label>
                <mat-select formControlName="invitationCompanyCode">
                  <mat-option *ngFor="let invitationCompanyCode of invitationCompanyCodeList"
                              [value]="invitationCompanyCode.respondentCompanyRollupCode"
                  >
                    {{ invitationCompanyCode.respondentCompanyRollupCode + " " + invitationCompanyCode.respondentCompanyRollupLabel }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Invitation Divisions</mat-label>
                <mat-select [multiple]="true" formControlName="invitationDivisionCodes">
                  <mat-option *ngFor="let invitationDivisionCodes of invitationDivisionCodesList"
                              [value]="invitationDivisionCodes.respondentCompanyRollupCode">
                    {{ invitationDivisionCodes.respondentCompanyRollupCode + ' ' + invitationDivisionCodes.respondentCompanyDivisionCode + ' ' + invitationDivisionCodes.respondentCompanyDivisionLabel }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Survey Language</mat-label>
                <mat-select formControlName="surveyLanguage">
                  <mat-option *ngFor="let surveyLanguage of surveyLanguageList"
                              [value]="surveyLanguage.language">
                    {{ surveyLanguage.language }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Nominated By</mat-label>
                <mat-select [multiple]="true" formControlName="nominatedByCodes">
                  <mat-option *ngFor="let buCategories of buCategoriesList"
                              [value]="buCategories.buCategoryCode">
                    {{ buCategories.buCategoryCode + ' ' + buCategories.buCategoryLabel }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex-row mg-b-m toggle-block custom-container">
              <div class="custom-left-container">
                <ag-three-state-selector
                  [formCtrl]="this.getFormControl('invalid')"
                  label="Valid / Invalid"
                  noLabel="Mark all Valid"
                  yesLabel="Mark all Invalid"
                ></ag-three-state-selector>
              </div>
            </div>
            <div class="flex-row custom-container">
              <mat-form-field class="mg-b-m">
                <mat-label>Nomination Notes</mat-label>
                <textarea formControlName="nominationNotes" matInput></textarea>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="featureComponentMode == FeatureComponentMode.BULK_MAILOUT" class="flex-row mg-b-m">
            <mat-form-field>
              <mat-label>Mailout Template</mat-label>
              <mat-select formControlName="mailoutTemplateCode">
                <mat-option *ngFor="let mailoutTemplateCode of mailoutTemplateCodeList"
                            [value]="mailoutTemplateCode.mailoutTemplateCode">
                  {{ mailoutTemplateCode.mailoutTemplateCode }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Mailout Field Set</mat-label>
              <mat-select formControlName="mailoutFieldSetCode">
                <mat-option *ngFor="let mailoutFieldsetCode of mailoutFieldsetCodeList"
                            [value]="mailoutFieldsetCode.mailoutFieldsetCode">
                  {{ mailoutFieldsetCode.mailoutFieldsetCode }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="getFormControl('mailoutDatetime')">
              <ag-datetimepicker [control]="getFormControl('mailoutDatetime')" [label]="'Mailout Datetime'" class="mat-mdc-form-field"></ag-datetimepicker>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="updateStage == 3" class="mg-b-m">
      <div class="bulk-update-progress-panel">
        <div class="bulk-update-progress-top-icon">
          <i class="fa-sharp fa-light fa-table fa-5x"></i>
        </div>
        <div class="flex-row flex-g-m">
          <div>
            <span>Processing Rows ({{ updateStatus.numberOfProcessedRows }} of {{ updateStatus.totalNumberOfRows }})</span>
          </div>
          <div class="right-align">
            <h3>{{ processedPercentage() }}%</h3>
          </div>
        </div>
        <div class="progress-bar-container">
          <mat-progress-bar color="primary" mode="determinate" value="{{processedPercentage()}}"></mat-progress-bar>
        </div>
        <div class="flex-row flex-g-m">
          <div>
            <span>Successful Rows ({{ updateStatus.numberOfSuccessRows }} of {{ updateStatus.numberOfProcessedRows }}) </span>
          </div>
          <div class="right-align">
            <h3>{{ successPercentage() }}%</h3>
          </div>
        </div>
        <div class="progress-bar-container">
          <mat-progress-bar color="accent" mode="determinate" value="{{successPercentage()}}"></mat-progress-bar>
        </div>
        <div class="flex-row flex-g-m">
          <div>
            <span>Unsuccessful Rows ({{ updateStatus.numberOfErrorRows }} of {{ updateStatus.numberOfProcessedRows }}) </span>
          </div>
          <div class="right-align">
            <h3>{{ errorPercentage() }}%</h3>
          </div>
        </div>
        <div class="progress-bar-container">
          <mat-progress-bar color="warn" mode="determinate" value="{{errorPercentage()}}"></mat-progress-bar>
        </div>
      </div>
    </div>
    <div>
      <div class="flex-row flex-g-s action-buttons">
        <button (click)="startProcessing()" *ngIf="updateStage == 2" [disabled]="this.featureComponentMode != FeatureComponentMode.UPLOAD && !this.hasAnyEdits()"
                color="primary" form="bulkUpdateForm" mat-raised-button type="submit">
          <mat-icon class="material-symbols-outlined">save</mat-icon>
          {{ submitButtonText }}
        </button>
        <button (click)="resetForm()" *ngIf="updateStage == 2 && featureComponentMode != FeatureComponentMode.UPLOAD" [disabled]="!this.hasAnyEdits()" mat-button
                type="button">
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
          Reset
        </button>
        <button (click)="abort()" *ngIf="updateStage == 3" [disabled]="!saveInProgress" mat-button>
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
          Abort
        </button>
        <button (click)="retry()" *ngIf="updateStage == 3" [disabled]="saveInProgress" mat-button>
          <mat-icon class="material-symbols-outlined">rotate_left</mat-icon>
          Retry
        </button>
        <button (click)="resetForm(); close()" *ngIf="updateStage == 2 || updateStage == 3" mat-button type="button">
          <i class="fa-sharp fa-light fa-xmark-large"></i> Close
        </button>
        <button (click)="this.downloadFailedRows('open-link-invitees-failed')" *ngIf="updateStage == 3" [disabled]="saveInProgress"
                class="right-align failed-rows-download-button" color="primary"
                mat-raised-button>
          <i class="fa-sharp fa-light fa-arrow-down-to-bracket"></i>
          <span class="button-span-margin-left">Download</span>
        </button>
      </div>
      <div class="flex-row full-width mg-t-m">
        <ag-grid-angular (gridReady)="onGridReady($event)"
                         [columnDefs]="tableColumns"
                         [rowData]="selectedRows"
                         [suppressPropertyNamesCheck]="true"
                         class="ag-theme-quartz ag-grid-flex record-display-table"></ag-grid-angular>
      </div>
    </div>
  </mat-card-content>
</mat-card>
